import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { config } from '../config/loader.js';
import Loading from './Loading.js';

/**
 * A page that moved to the web app (2026-10-07: the control hub's pages and
 * kiosk mode). The redirect Worker in front of this host sends DOCUMENT
 * loads there, but a link clicked inside this SPA never reaches it — so the
 * route itself sends the browser on, replacing the history entry.
 */
export default function MovedToWebApp({
  to,
}: {
  /** The page's path on the web app, from this route's params. */
  to: (params: Readonly<Partial<Record<string, string>>>) => string;
}): React.JSX.Element {
  const params = useParams();
  const target = `${config.webAppUrl.replace(/\/$/, '')}${to(params)}`;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return <Loading />;
}
